import React from 'react'
import {observer} from 'mobx-react-lite'
import {Marker} from '../../../../components/store-map/marker'
import {StoreDetailResponseItem} from '../../../../types/store/storeDetails'
import {StoreMap} from '../../../../components/store-map'
import {noop} from '../../../../utils/utils'

interface StoreMapProps {
  store: StoreDetailResponseItem
  mapOptions: {
    center: {
      lat: number
      lng: number
    }
    zoom: number
  }
}

export const StoreDetailMap = observer(function StoreDetailMap(props: StoreMapProps) {
  const {mapOptions, store} = props

  return (
    <StoreMap mapOptions={mapOptions}>
      <Marker
        setLastMarkerPlaced={noop}
        num={0}
        selectedMarkerId={store.id}
        isStoreDetailsMarker
        storeDetail={store}
        options={{
          position: {
            lat: store.latitude,
            lng: store.longitude,
          },
        }}
      />
      )
    </StoreMap>
  )
})
